import PropTypes from 'prop-types';
import classNames from 'classnames';

import { getCurrencySymbolForISOCode } from '@spotahome/soyuz-currency';

import './SuggestPriceModalIcon.scss';

const SuggestPriceModalIcon = ({ currencyIsoCode }) => {
  const currencySymbol = getCurrencySymbolForISOCode(currencyIsoCode);

  const symbolClassNames = classNames(
    'suggest-price-modal-icon__currency-symbol',
    {
      'suggest-price-modal-icon__currency-symbol--small':
        currencySymbol.length > 1
    }
  );

  return (
    <div className="suggest-price-modal-icon">
      <p className={symbolClassNames}>{currencySymbol}</p>
    </div>
  );
};

SuggestPriceModalIcon.propTypes = {
  currencyIsoCode: PropTypes.string.isRequired
};

export default SuggestPriceModalIcon;
